/* eslint-disable @next/next/no-img-element -- A team logo is a local asset (mostly SVG, which next/image serves
   unoptimized); a plain img costs nothing and no image-optimization usage. */
import { cn } from '@sharpr/ui';
import { getTeamLogo, getDarkModeLogo } from '../constants/teamLogos';
import type { Sport } from '@sharpr/types';

interface TeamLogoProps {
  team: string;
  sport: Sport;
  className?: string;
}

export function TeamLogo({ team, sport, className }: TeamLogoProps) {
  const logo = getTeamLogo(team, sport);
  const darkLogo = getDarkModeLogo(team);

  if (!logo) return null;

  if (darkLogo) {
    return (
      <>
        <img
          src={logo}
          alt={team}
          className={cn("object-contain flex-shrink-0 dark:hidden", className)}
          loading="lazy"
        />
        <img
          src={darkLogo}
          alt={team}
          className={cn("object-contain flex-shrink-0 hidden dark:block", className)}
          loading="lazy"
        />
      </>
    );
  }

  return (
    <img
      src={logo}
      alt={team}
      className={cn("object-contain flex-shrink-0", className)}
      loading="lazy"
    />
  );
}
